export const Features = (props) => {
  return (
      <div className="features-style2-area" id='features'>
        <div className="features-style2-area--bg" style={{ backgroundImage: "url(/img/service-page-sec1-bg.png)" }}></div>
        <div className="container">
          <div className="row">

            <div className="col-xl-8">
              <div className="features-style1_one-content features-style1_two-content">
                <div className="inner-content">
                  <div className="sec-title">

                    <h2>Why Choose Us ?</h2>
                    <h6>One of The Best RO Service Providers</h6>

                  </div>
                  <div className="text">
                    <ul>
                      <li><span className="icon-water-drop"><i className="fa-solid fa-droplet"></i>&nbsp;</span> <b>Experienced &amp; Trained Technicians</b><br /></li>

                      <li><span className="icon-water-drop"><i className="fa-solid fa-droplet"></i>&nbsp;</span> <b>Fast and Reliable Home Service</b><br />
                      </li>
                      <li><span className="icon-water-drop"><i className="fa-solid fa-droplet"></i>&nbsp;</span> <b>Genuine Spare Parts </b><br />
                      </li>
                      <li><span className="icon-water-drop"><i className="fa-solid fa-droplet"></i>&nbsp;</span> <b>Affordable &amp; Transparent Pricing </b><br /></li>
                      <li><span className="icon-water-drop"><i className="fa-solid fa-droplet"></i>&nbsp;</span> <b>Customer-Focused Support</b><br />
                      </li>
                    </ul>

                    <h4>About Us </h4>
                    <p>We provide RO water purifier services including repair.Installation.AMC and sales. We promise to deliver service to your home within one hour. Please contact us on our toll-free customer care number.</p>

                  </div>
                </div>
              </div>
            </div>

            <div className="col-xl-4">
              <div className="video-holder-box1">
                <div className="video-holder-box1-bg" style={{backgroundImage: "url(img/gallery.jpg)" }}></div>
                {/* <!--<div className="icon">
                  <a className="video-popup paroller" title="Video Gallery" href="https://www.youtube.com/watch?v=p25gICT63ek">
                    <span className="icon-play playicon"></span>
                  </a>
                </div>--> */}
              </div>
            </div>

          </div>
        </div>
      </div>
  )
}
